// src/components/call/CallButtonBar.jsx
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { startCall, hangup } from '../../actions/call.actions';

export default function CallButtonBar({ peerId, peerName, chatId, isGroup }) {
    const dispatch = useDispatch();
    const call = useSelector(s => s.call);
    if (!peerId) return null;

    const inProgress = call.status !== 'idle';
    const disabled = inProgress || !!isGroup;

    if (call.status === 'in-call' && (String(call.peerId) === String(peerId) || call.peerId == null)) {
        return (
            <div className="callbar">
                <button className="iconBtn" onClick={() => dispatch(hangup('ended'))} title="Завершить">⛔</button>
            </div>
        );
    }

    return (
        <div className="callbar">
            <button className="iconBtn" disabled={disabled} onClick={() => dispatch(startCall({ to: peerId, video: false, chatId }))} title={`Позвонить ${peerName || ''}`}>🔊</button>
            <button className="iconBtn" disabled={disabled} onClick={() => dispatch(startCall({ to: peerId, video: true, chatId }))} title={`Видео ${peerName || ''}`}>🎥</button>
        </div>
    );
}
